import type { JSX } from 'react';

import { Permission } from '@bookora/shared';
import { Space, Typography } from '@bookora/ui';

import { LinkButton } from '@/components/link-button';
import { useCan } from '@/permissions/use-can';

import { useBranchContext } from './hooks';

const { Paragraph } = Typography;

/**
 * «شعبه‌ها» in the «راهنما و پیشنهادها» hub: where each branch thing lives,
 * for the people who run more than one site. Registered by `register.ts`.
 */
export function BranchesHubSection(): JSX.Element {
  const canManage = useCan(Permission.BRANCH_MANAGE);
  const canTransfer = useCan(Permission.INVENTORY_ADJUST);
  const canViewStaff = useCan(Permission.STAFF_VIEW);
  const { isMulti } = useBranchContext();
  return (
    <Space orientation="vertical" size={8} style={{ width: '100%' }}>
      <Paragraph type="secondary" style={{ marginBlockEnd: 0 }}>
        هر شعبه تقویم، اتاق، صندوق و انبار خودش رو داره؛ پرونده بیمار و فهرست خدمات در همهٔ شعبه‌ها
        یکی است.
        {isMulti ? ' شعبهٔ نمایش‌داده‌شده رو از کنار نام کلینیک عوض کنید.' : ''}
      </Paragraph>
      {canManage ? (
        <LinkButton type="link" size="small" to="/settings?tab=branches">
          مدیریت شعبه‌ها
        </LinkButton>
      ) : null}
      {canViewStaff ? (
        <LinkButton type="link" size="small" to="/staff">
          کارکنان هر شعبه
        </LinkButton>
      ) : null}
      {isMulti && canTransfer ? (
        <LinkButton type="link" size="small" to="/inventory?tab=transfers">
          انتقال موجودی بین شعبه‌ها
        </LinkButton>
      ) : null}
    </Space>
  );
}
